import { render, staticRenderFns } from "./newSubmit.vue?vue&type=template&id=01f6fd8c&scoped=true&"
import script from "./newSubmit.vue?vue&type=script&lang=js&"
export * from "./newSubmit.vue?vue&type=script&lang=js&"
import style0 from "./newSubmit.vue?vue&type=style&index=0&id=01f6fd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f6fd8c",
  null
  
)

export default component.exports